import React from 'react'
import { Icon } from "@material-ui/core";
import ethlogo from './logos/ethlogo.svg'

export const Logo = () => (
    <Icon>
        <img src={ethlogo} height={25} width={25}/>
    </Icon>
)